// 期(会計年度)の算出(純関数)。firebaseに依存しないためJestで直接テストできる。
//
// 期は毎年6月1日はじまり。カテゴリごとの購入上限は期をまたぐとリセットされるため、
// 「その注文がどの期に属するか」は注文日(placed_at)で決まる。
// 注文日を後から訂正すると帰属する期が変わるので、UIでは必ず期を明示する。

// 期首の月(1始まり)
export const FISCAL_YEAR_START_MONTH = 6;

// 期番号の基準。64期 = 2025/6/1〜2026/5/31 (依頼元の定義)。
// 期番号を変えたくなった場合はここだけを直せばよい。
export const FISCAL_YEAR_ANCHOR = { fiscalYear: 64, startYear: 2025 };

// 期首の西暦年から期番号を求める(例: 2025 → 64期)
export const toFiscalYearNumber = (startYear) =>
  FISCAL_YEAR_ANCHOR.fiscalYear + (startYear - FISCAL_YEAR_ANCHOR.startYear);

// 指定日が属する期の「期首の西暦年」を求める
export const getFiscalStartYear = (date) => {
  // 6月より前(0〜4月 = 1〜5月)なら前年の6月1日が期首
  return date.getMonth() < FISCAL_YEAR_START_MONTH - 1
    ? date.getFullYear() - 1
    : date.getFullYear();
};

// 指定日が属する期の初日(6月1日 0時0分0秒)を返す
export const getFiscalYearStart = (date) =>
  new Date(getFiscalStartYear(date), FISCAL_YEAR_START_MONTH - 1, 1, 0, 0, 0, 0);

const formatYmdSlash = (date) =>
  `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;

// 指定日が属する期の情報を返す。日付が不正な場合はnull。
// 戻り値: { fiscalYear, startYear, start, end, label, rangeLabel }
export const getFiscalYear = (date) => {
  if (!date) {
    return null;
  }
  const target = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(target.getTime())) {
    return null;
  }
  const startYear = getFiscalStartYear(target);
  const start = getFiscalYearStart(target);
  // 翌期の初日の1ミリ秒前 = 5月31日 23:59:59.999
  const end = new Date(
    new Date(startYear + 1, FISCAL_YEAR_START_MONTH - 1, 1, 0, 0, 0, 0).getTime() - 1
  );
  const fiscalYear = toFiscalYearNumber(startYear);
  return {
    fiscalYear,
    startYear,
    start,
    end,
    label: `${fiscalYear}期`,
    rangeLabel: `${formatYmdSlash(start)}〜${formatYmdSlash(end)}`,
  };
};

// 2つの日付が同じ期に属するか。どちらかが不正ならfalse。
export const isSameFiscalYear = (a, b) => {
  const fyA = getFiscalYear(a);
  const fyB = getFiscalYear(b);
  return fyA != null && fyB != null && fyA.startYear === fyB.startYear;
};
